import { createAction } from '@reduxjs/toolkit'
import { usePubNubUtils } from '~/features/member-profile/communication'
import { useAuth0, type LogoutOptions } from '@auth0/auth0-react'
import { useMutation } from '~/shared/hooks/useMutation'
import { logger } from '~/shared/lib/logger'
import { removeIdToken, removeSessionToken } from '~/shared/lib/auth'

export const auth0Authenticate = createAction('auth0/authenticate')
export const auth0Deauthenticate = createAction('auth0/deauthenticate')

export const useLogoutEffects = (options?: { auth0?: LogoutOptions }) => {
  const auth0 = useAuth0()
  const { disconnectFromPubNub } = usePubNubUtils()
  return useMutation(() => {
    logger.debug('[Session] useLogoutEffects mutation')
    removeSessionToken()
    removeIdToken()
    // Kick off the Auth0 logout before the PubNub teardown: the teardown asserts on a loaded
    // `me` slice, and its throw must not be what keeps the user signed in.
    const loggedOut = auth0.logout({ ...options?.auth0 })
    disconnectFromPubNub()
    return loggedOut
  })
}
